import uniqBy from 'lodash/uniqBy'

const getNewId = (choices, count = 0) => {
  const id = choices.length + count
  const item = choices.find((choice) => choice.value === `value-${id}`)
  if (item) {
    return getNewId(choices, count + 1)
  }
  return id
}

export const getNewChoice = (choices) => {
  const id = getNewId(choices)
  return {
    label: `fields.answer.default`,
    value: `value-${id}`,
  }
}

export const handleAddAnswerCommon = (model) => async () => {
  const settings = model.settings.values

  try {
    const choices = settings.choices || []
    const newChoice = getNewChoice(choices)
    model.settings.set({
      choices: uniqBy(
        [
          ...choices,
          newChoice,
        ],
        'value'
      ),
    })
  } catch (e) {}
}
